var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFnnIcon = function SvgFnnIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3986 47.2536L32.627 43.4512L16.4988 31.7075L11.2651 35.5313L27.3986 47.2536Z",
    fill: "url(#paint0_linear_3756_15300)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9997 26.3058L45.989 20.1643L29.8555 31.9L31.8848 38.0548L47.9997 26.3058Z",
    fill: "url(#paint1_linear_3756_15300)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58838 39.1015L12.8087 42.9146L19.0597 23.972L13.818 20.1562L7.58838 39.1015Z",
    fill: "url(#paint2_linear_3756_15300)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.835449 34.1643L6.0504 37.9774L12.3041 19.0348L7.06243 15.219L0.835449 34.1643Z",
    fill: "url(#paint3_linear_3756_15300)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5977 12.8718L0.603027 19.016L20.5523 19.0454L22.539 12.8772L2.5977 12.8718Z",
    fill: "url(#paint4_linear_3756_15300)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1802 4.91455L3.18555 11.0614L23.1321 11.0908L25.1215 4.92257L5.1802 4.91455Z",
    fill: "url(#paint5_linear_3756_15300)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0293 0.017334H19.5674L25.6982 19L32.1762 18.9893L26.0293 0.017334Z",
    fill: "url(#paint6_linear_3756_15300)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3951 0.017334H27.9331L34.064 19L40.5446 18.9893L34.3951 0.017334Z",
    fill: "url(#paint7_linear_3756_15300)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1653 42.3298L39.3882 38.5274L23.2627 26.7864L18.0317 30.6075L34.1653 42.3298Z",
    fill: "url(#paint8_linear_3756_15300)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3935 18.3566L43.3801 12.2151L27.252 23.9508L29.2786 30.1029L45.3935 18.3566Z",
    fill: "url(#paint9_linear_3756_15300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3756_15300",
    x1: 21.9461,
    y1: 31.7075,
    x2: 21.9461,
    y2: 47.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3756_15300",
    x1: 38.9276,
    y1: 20.1643,
    x2: 38.9276,
    y2: 38.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3756_15300",
    x1: 13.324,
    y1: 20.1562,
    x2: 13.324,
    y2: 42.9146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3756_15300",
    x1: 6.56977,
    y1: 15.219,
    x2: 6.56977,
    y2: 37.9774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3756_15300",
    x1: 11.571,
    y1: 12.8718,
    x2: 11.571,
    y2: 19.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3756_15300",
    x1: 14.1535,
    y1: 4.91455,
    x2: 14.1535,
    y2: 11.0908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3756_15300",
    x1: 25.8718,
    y1: 0.017334,
    x2: 25.8718,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3756_15300",
    x1: 34.2389,
    y1: 0.017334,
    x2: 34.2389,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3756_15300",
    x1: 28.71,
    y1: 26.7864,
    x2: 28.71,
    y2: 42.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3756_15300",
    x1: 36.3227,
    y1: 12.2151,
    x2: 36.3227,
    y2: 30.1029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CBCACA"
  })))));
};
export default SvgFnnIcon;